import { BankaccountModel } from './bankaccount.model'
import { PaginationModel } from './pagination.model'

export class BankaccountResponseModel {
  pagination: PaginationModel
  items: BankaccountModel[] = []

  constructor(data) {
    this.pagination = data.pagination
    if (data.items !== null) {
      for (const account of data.items) {
        this.items.push(new BankaccountModel(account))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/models/bankaccount-response.model.ts